// extracted by mini-css-extract-plugin
export default {"root":"styles_root__JnjN5","terms":"styles_terms__4QAl-","blueLink":"styles_blueLink__RzJKN","noLink":"styles_noLink__VWmvE"};